import axiosAuth from '../../../shared/configs/axios-auth'

const getDefaultState = () => {
    return {
        orders: [],
        orderState: {},
        order: null,
        slots: [],
        loadingSlots: null,
        ordersNumber: 0
    }
}

const state = getDefaultState()

const getters = {
    orders: state => {
        return state.orders
    },
    orderState: state => {
        return state.orderState
    },
    order: state => {
        return state.order
    },
    slots: state => {
        return state.slots
    },
    ordersNumber: state => {
        return state.ordersNumber
    },
    loadingSlots: state => {
        return state.loadingSlots
    },
}

const mutations = {
    resetState (state) {
        Object.assign(state, getDefaultState())
    },
    orders: (state, payload) => {
        state.orders = payload
    },
    orderState: (state, payload) => {
        state.orderState = payload
    },
    order: (state, payload) => {
        state.order = payload
    },
    slots: (state, payload) => {
        state.slots = payload
    },
    ordersNumber: (state, payload) => {
        state.ordersNumber = payload
    },
    loadingSlots: (state, payload) => {
        state.loadingSlots = payload
    },
}

const actions = {
    getNumberOrders: ({commit}) =>{
        axiosAuth.get('/orders/number')
        .then(
            res => {
                commit('ordersNumber', res.data)
            }
          )
          .catch(
            () => {}
          )
    },

    getOrders: ({commit}) =>{
        // commit('updating', true)
        axiosAuth.get('/orders')
        .then(
            res => {
                if(!res.data.message){
                    commit('orders', res.data)
                }
            }
          )
          .catch(
            error => {
              console.log(error.response)
            //   commit('updating', false)

            }
          )
    },

    getOrder: ({commit}, payload) =>{
        commit('updating', true)
        axiosAuth.get('/orders/order/' + payload._id)
        .then(
            res => {
                commit('updating', false)
                if(!res.data.message){
                    commit('order', res.data)
                }
            }
          )
          .catch(
            error => {
              console.log(error.response)
              commit('updating', false)

            }
          )
    },

    postOrder ({commit}, payload) {
        commit('updating', true)
        axiosAuth.post('/orders', payload)
            .then(
                res => {
                    commit('orderState', res.data)
                    commit('updating', false)
                }
            )
            .catch(
            error => {
                console.log(error.response)
                commit('updating', false)
            }
        )
    },

    updateOrder: ({commit, dispatch}, payload) => {        
        commit('updating', true)
        axiosAuth.patch('/orders/setstatus/'+ payload._id, payload.data)
        .then(
            res => {
                commit('orderState', res)
                commit('updating', false)
                dispatch('getOrder', {_id: payload._id})
                dispatch('getOrders')
            }
          )
        .catch(
            error => {
                console.log(error.response)
                commit('updating', false)
            }
        ) 
    },

    checkSlots: ({commit}, payload) =>{
        commit('loadingSlots', true)
        axiosAuth.get('/companies/checkSlots/' + payload.company + '/' + payload.date + '/false')
        .then(
            res => {
                commit('loadingSlots', false)
                if(!res.data.message){
                    commit('slots', res.data)
                }
            }
          )
          .catch(
            error => {
              console.log(error.response)
              commit('loadingSlots', false)

            }
          )
    },

}

export default {
    state,
    getters,
    mutations,
    actions
}